import { useResetCheckoutStartedOnLeave } from './useResetCheckoutStartedOnLeave';

const PulseCheckoutStartedTracker = (): null => {
  useResetCheckoutStartedOnLeave();
  return null;
};

export default PulseCheckoutStartedTracker;
